<script>
export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		page: {
			type: Number,
			required: true
		},
    range: {
      type: Number,
      default: 2
    }
	},
  computed: {
    pagesArray() {
      return Array.from(Array(+this.data.total_pages).keys(), item => item + 1);
    },
    displayedPages() {
      // Calculate the first and last page numbers to display.
      let start = Math.max(1, this.page - this.range);
      let end = Math.min(this.page + this.range, +this.data.total_pages);

      // Ensure the range is centered within the available pages.
      if (end - start < 2 * this.range) {
        if (start === 1) {
          end = Math.min(end + 2 * this.range - (end - start), +this.data.total_pages);
        } else {
          start = Math.max(start - 2 * this.range + (end - start), 1);
        }
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
	methods: {
		changePage(page) {
			if (page < 1) page = 1;
			if (page > +this.data.total_pages) page = +this.data.total_pages;
			this.$emit('updatePage', page);
		},
	},
}
</script>
<template>
	<div class="row">
		<div class="col">
			<nav class="d-flex justify-content-center">
				<ul class="pagination pagination-custom mb-0">
          <!-- Flecha atrás -->
					<li class="page-item" v-show="displayedPages.length > 1" :class="page === 1 ? 'disabled' : '' ">
						<a 
              @click="changePage(page - 1)"
              href="javascript:"
              class="page-link border-0"
            >
            <font-awesome-icon icon="fa-solid fa-angle-left"></font-awesome-icon>
						</a>
					</li>


          <!-- Display a range of pages centered around the actual page -->
          <li
            v-for="num in displayedPages"
            :key="num"
            :class="page === num ? 'page-item active' : 'page-item'"
          >
            <a
              @click="changePage(num)"
              class="page-link border-0"
              href="javascript:"
            >
              {{ num }}
            </a>
          </li>

          <!-- Flecha adelante -->
					<li class="page-item" v-show="displayedPages.length > 1" :class="page === +data.total_pages ? 'disabled' : '' ">
						<a 
              @click="changePage(page + 1)"
              class="page-link border-0" 
              href="javascript:"
						>
              <font-awesome-icon icon="fa-solid fa-angle-right"></font-awesome-icon>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>
